import { Form } from "@/components/ui/form";
import { useEditForm } from "@/features/Edit/hooks";
import { EditFormProps } from "@/features/Edit/types.ts";
import { FormActionsUpdate } from "@/features/FormCard/Actions.tsx";
import { Diff } from "@/features/FormCard/Diff.tsx";
import {
  ConfirmationModal,
  DeleteConfirmationModal,
} from "@/features/FormCard/Modals.tsx";
import { useEffect } from "react";

export function EditFormWrapper({
  client,
  id,
  table_name,
  headerText,
  formBodyContent,
  multiFieldOptions,
  formSchema,
  adjustData,
  fieldChangeCallBack,
  allowDelete,
}: EditFormProps) {
  const {
    form,
    handleReset,
    onSubmit,
    confirmUpdate,
    cancelUpdate,
    isConfirmationModalOpen,
    isDeleteModalOpen,
    openDeleteModal,
    closeDeleteModal,
    isUpdating,
    isDeleting,
    handleDelete,
    changedFields,
    fetchedData,
  } = useEditForm({
    client,
    id,
    table_name,
    FormSchema: formSchema,
    adjustData,
  });

  useEffect(() => {
    if (!fetchedData || !fieldChangeCallBack) return;

    Object.keys(fetchedData).forEach((key) => {
      if (fieldChangeCallBack[key]) fieldChangeCallBack[key](fetchedData[key]);
    });
  }, [fetchedData, fieldChangeCallBack]);

  return (
    <div>
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} onReset={handleReset}>
          <div>{headerText}</div>
          <div className="flex flex-col gap-2">
            {formBodyContent(form, multiFieldOptions)}
          </div>
          <div className="p-1">
            <FormActionsUpdate
              client={client}
              elementId={id}
              onReset={handleReset}
              onDelete={openDeleteModal}
              allowDelete={allowDelete}
              isDirty={form.formState.isDirty}
            />
          </div>
        </form>
      </Form>
      <ConfirmationModal
        isOpen={isConfirmationModalOpen}
        isLoading={isUpdating}
        onClose={cancelUpdate}
        onConfirm={confirmUpdate}
        title="Confirmer les modifications"
        titleKey="confirm_update"
        children={changedFields ? Diff(changedFields) : "Aucune modification"}
        childrenKey={!changedFields ? "no_changes" : undefined}
      />
      <DeleteConfirmationModal
        isOpen={isDeleteModalOpen}
        onClose={closeDeleteModal}
        onDelete={handleDelete}
        isLoading={isDeleting}
        requireTyping
      />
    </div>
  );
}
